module.exports = __webpack_public_path__ + "img/unit2-federated.4ad976cc.svg";